import {
    GET_DISTRICTS_REQUEST,
    GET_DISTRICTS_SUCCESS,
    GET_DISTRICTS_FAILURE
} from '../actions';

const initialState = {
    data: [],
    page:1,
    hasMore:true
};

const DistrictsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DISTRICTS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_DISTRICTS_SUCCESS:
            if(action.payload.length === 0){
                return Object.assign({},state,
                    {asyncStatus:  'SUCCESS',
                        data: [],
                        page: 1,
                        hasMore: false
                    });
            }
            if(action.search !== "" || action.flag === 0){
                state = initialState;
            }
            let newData= action.payload || [];
            if(state.data.results){
                newData["results"] = [...state.data.results,...action.payload.results];
            }
            return Object.assign({},state, {asyncStatus:  'SUCCESS',
                data: newData,
                hasMore:action.payload.nextPage !== -1,
                page: action.payload.currentPage
            });
        case GET_DISTRICTS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default DistrictsReducer;